const secondHandlers: Map<string, () => void> = new Map();

export function addEventListener(index: string, handler: () => void) {
  secondHandlers.set(index, handler);
}

export function removeEventListener(index: string) {
  secondHandlers.delete(index);
}

function handleTick() {
  secondHandlers.forEach((h) => h());
}

setInterval(handleTick, 1000);
